<template>
  <div v-if="!isProd && !hideEnvBar" class="dev-overlay-bar">
    <button type="button" class="bar-item hide-overlaybar-btn" @click="closeEnvBar">
      X
    </button>

    <button type="button" class="bar-item env-info" @click="openOverlay">
      <span class="env-name">
        Ambiente de desenvolvimento
      </span>
    </button>

    <div :class="['dev-overlay', { open: isContentOpen }]" @click="closeOverlay">
      <div class="overlay-card" @click.stop>
        <GroupsList class="groups-list" />
        <div class="separator" />
        <GroupsView class="groups-view" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';

import useDevOverlayStore from '@/stores/devOverlay';

import GroupsList from './GroupsList.vue';
import GroupsView from './GroupsView.vue';

export default {
  components: { GroupsView, GroupsList },
  setup() {
    const devOverlayStore = useDevOverlayStore();

    const isContentOpen = ref(false);

    const isProd = appSettings.VUE_APP_AMBIENTE === 'prd';

    if (isProd) {
      logger.error('DevOverlay tentou executar em produção', { domain: document.domain });
      logger.tracker.error('DevOverlay tentou executar em produção', { domain: document.domain });
    }

    const hideEnvBar = ref(false);

    const closeEnvBar = () => {
      hideEnvBar.value = true;
    };

    const openOverlay = () => {
      devOverlayStore.reloadConfig();
      isContentOpen.value = true;
    };

    const closeOverlay = () => {
      isContentOpen.value = false;
      devOverlayStore.saveConfig();
    };

    return {
      isContentOpen,
      isProd,
      hideEnvBar,
      closeEnvBar,
      closeOverlay,
      openOverlay,
    };
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/styles/vars" as *;

$yellow: #F2A417;
$black: #141617;

.dev-overlay-bar {
  background: $yellow repeating-linear-gradient(-55deg, #0000, #0000 20px, $black 20px, $black 40px);
  padding: .25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;

  @include responsive($tablet) {
    padding: .1rem;
  }

  > .bar-item {
    background: $yellow;
    font-size: .75rem;
    font-weight: 600;
    padding: .2rem .5rem;
    border: 1px solid $black;
  }
}

.env-info {
  flex: 1 1 auto;
  display: grid;
  grid-template: "warnL envName warnR"
    / min-content 1fr min-content;
  justify-content: center;
  align-items: center;
  gap: .5em;
  width: 100%;
  max-width: 700px;
  text-align: center;
  text-transform: uppercase;
  font-stretch: 25%;
  line-height: 1;

  &:before {
    content: '⚠️';
    grid-area: warnL;
  }

  &:after {
    content: '⚠️';
    grid-area: warnR;
  }

  .env-name {
    grid-area: envName;
  }

  .overlay-btn {
    grid-area: btn;
    font-size: inherit;
    padding: .25rem .5em;
    background: #FFF;

    text-align: center;
    font-weight: 500;
    border-radius: 5px;
    transition: outline .1s ease-in-out;
    outline: 1px solid transparent;
    outline-offset: 1px;
    border: 1px solid $black;

    &:not(:disabled) {
      &:hover,
      &:active,
      &:focus-visible {
        outline: 1px solid $black;
      }

      &:active {
        outline-offset: 0;
      }
    }
  }
}

.dev-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  background: transparent;
  transition: background-color .15s ease-in-out;
  z-index: 9999;
  display: grid;
  place-items: center;

  .overlay-card {
    display: flex;
    height: calc(100% - 2rem);
    width: calc(100% - 2rem);
    max-width: 1200px;
    background: #FFF;
    transform: translateY(100vh);
    transition: transform .15s ease-in-out;
    border-radius: 5px;
    padding: 1rem;

    .separator {
      content: '';
      display: block;
      height: 100%;
      width: 1px;
      background: #CCC;
      margin: 0 .5rem;
    }

    .groups-list {
      flex: 0 0 auto;
    }

    .groups-view {
      flex: 1 1 auto;
    }
  }

  &.open {
    transform: none;
    background: #000C;

    .overlay-card {
      transform: translateY(0);
    }
  }
}
</style>
